import axios from 'axios';
import logCollector from '@/common/logCollector';
import store from '@/store/index';
import config from '@/common/config';

/**
 * Initializes or configures axios library.
 * The constructor is used to configure everything that can be done upfront, whereas
 * the method onSuccessfulLogin is called when the user has successfully logged in.
 */
class AxiosInitializer {
  constructor() {

  }
  init(){
    console.log("Configure axios with baseUrl and required headers")
    let { screen, browser, browserVersion, mobile, os, osVersion } = config.browserInfo;
    axios.defaults.baseURL = `${window.location.origin}/api`; //;configs.apiUrl;
    // console.log('Axios Initializer axios.defaults.baseUR', axios.defaults.baseURL);
    axios.defaults.headers.common['Content-Type'] = 'application/json';
    // axios.defaults.headers.common['Accept-Encoding'] = 'gzip, deflate';
    axios.defaults.headers.common['client-app-version'] = process.env.VUE_APP_UI_VERSION;
    axios.defaults.headers.common['client-browser'] = browser;
    axios.defaults.headers.common['client-browser-version'] = browserVersion;
    axios.defaults.headers.common['client-mobile'] = mobile;
    axios.defaults.headers.common['client-os'] = os;
    axios.defaults.headers.common['client-os-version'] = osVersion;
    axios.defaults.timeout = 0;
    //axios.defaults.withCredentials = true;
  }
  /**
   * Configures axios interceptors for request and responses.
   * Requests get appended the JWT token stored in localStorage and
   * responses try to 'heal' unsuccessful authorization by a expedited token
   * by refreshing the token and re-performing the failed request.
   */
  onSuccessfulLogin(token) {
    // do not use interceptors because we have already one interceptor with the service-worker and
    // using axios interceptors increases complexity
    // setRequestInterceptor(token);
    setResponseInterceptor();
  }
}

/**
 * Intercept requests before they are handled by then or catch.
 */
function setRequestInterceptor(token) {
  axios.interceptors.request.use(
    (request) => {
      return request;
    },
    (error) => {
      logCollector('axios request interceptor error', error);
      Promise.reject(error);
    }
  );
}

function setResponseInterceptor() {
  // Intercept responses before they are handled by then or catch.
  // Any status code that lie within the range of 2xx cause this function to trigger
  // Do something with response data
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    (error) => {
      let url = error && error.response && error.response.config ? error.response.config.url : 'no url defined';
      if (url.includes('cockpitLog')) {
        // ignore cockpitLog failures, since it can lead to login cycles when the cookie has expired
        return;
      }
      console.log('axios response interceptor caught', JSON.stringify(error, null, 2));

      if (error && error.response && (error.response.status === 401 || error.response.status === 403)) {
        store.dispatch('stopServerReachabilityCheck');
        // AuthException
        console.log('Api request failed due to missing authentication. Reset state to display login page');
        store.dispatch('lifecycle/setAppStates', { authenticated: false, configsLoaded: true }, { root: true });
        return Promise.reject(error);
      }
      if (error && error.response && error.response.data) {
        console.log('axios response interceptor caught error with request', url);
      }
      Promise.reject(error);
    }
  );
}

export default new AxiosInitializer();
